// extracted by mini-css-extract-plugin
export default {"savedCardContainer":"SavedCard_savedCardContainer__pGXBQ"};